import { InitConfiguration, Configuration } from '@/config/config'

declare global {
    interface Window {
        __MBC_MFE_REMOTE_URL__?: string
    }
}

(async () => {
    await InitConfiguration()
    window.__MBC_MFE_REMOTE_URL__ = Configuration.MBC_MFE_REMOTE_URL
    await import('./bootstrap')
})()
